module.exports = __webpack_public_path__ + "img/j2.75090cb8.png";